module.exports = __webpack_public_path__ + "assets/strapi.a1efd323.svg";